export const DntMenuIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '20'}
    height={props?.height || '20'}
    fill={props?.color || '#667085'}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M5.636,4.222a1,1,0,0,1,0,1.414,9.01,9.01,0,0,0,0,12.728,1,1,0,1,1-1.414,1.414,11.012,11.012,0,0,1,0-15.556A1,1,0,0,1,5.636,4.222ZM18.364,18.364a1,1,0,1,0,1.414,1.414,11.012,11.012,0,0,0,0-15.556,1,1,0,1,0-1.414,1.414A9.01,9.01,0,0,1,18.364,18.364ZM7.379,17.692l.036.035a.941.941,0,0,0,.65.261,1.018,1.018,0,0,0,.728-.316,1.031,1.031,0,0,0-.036-1.429,6.008,6.008,0,0,1,0-8.486A1,1,0,1,0,7.343,6.343,8.02,8.02,0,0,0,7.379,17.692Zm7.972-11.3A1,1,0,0,0,15.337,7.8a6.019,6.019,0,0,1-.044,8.442,1,1,0,1,0,1.414,1.414A8.025,8.025,0,0,0,16.765,6.4,1,1,0,0,0,15.351,6.387ZM15,12a3,3,0,1,1-3-3A3,3,0,0,1,15,12Zm-2,0a1,1,0,1,0-1,1A1,1,0,0,0,13,12Z"></path>
    </g>
  </svg>
);
